export default {
    tabSelect(state, isTabSelect) {
        state.isTabSelect = isTabSelect
    }, 
    isListTab(state, isListTab) {
        state.isListTab = isListTab
    }, 
};
